export const INITIATE_APPLICATION_SETTINGS = 'INITIATE_APPLICATION_SETTINGS';

//dataset actions
export const FETCHING_DATASET_REQUEST = 'FETCHING_DATASET_REQUEST';
export const FETCHING_DATASET_SUCCEDDED = 'FETCHING_DATASET_SUCCEDDED';
export const FETCHING_DATASET_FAILED = 'FETCHING_DATASET_FAILED';


//Seek
export const SEEK_ANSWER_FOR_QUESTION_REQUEST = "SEEK_ANSWER_FOR_QUESTION_REQUEST";
export const SEEK_EVENT_FOR_QUESTION_SUCCEEDED = "SEEK_EVENT_FOR_QUESTION_SUCCEEDED";
export const SEEK_ANSWER_FOR_QUESTION_SUCCEEDED = "SEEK_ANSWER_FOR_QUESTION_SUCCEEDED";
export const SEEK_ANSWER_FOR_QUESTION_FAILED = "SEEK_ANSWER_FOR_QUESTION_FAILED";
export const INVALIDATE_SEEK_SESSION = "INVALIDATE_SEEK_SESSION";

export const FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT = "FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT";
export const FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT_SUCCEEDED = "FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT_SUCCEEDED";
export const FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT_FAILED = "FETCHING_SEEKQA_SUGGESTIONS_FOR_ACCOUNT_FAILED";

export const PROVIDE_FEEDBACK_FOR_CHAT = "PROVIDE_FEEDBACK_FOR_CHAT";
export const PROVIDING_FEEDBACK_FOR_CHAT_SUCCEEDED = "PROVIDING_FEEDBACK_FOR_CHAT_SUCCEEDED";
export const PROVIDING_FEEDBACK_FOR_CHAT_FAILED = "PROVIDING_FEEDBACK_FOR_CHAT_FAILED";

export const INVALIDATE_SEEK_CHAT_ANIMATION= "INVALIDATE_SEEK_CHAT_ANIMATION";